"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Form = void 0;
const React = require("react");
const _ = require("lodash");
const ErrorPlaceholder_1 = require("../../structure/ErrorPlaceholder");
const FormInner_1 = require("./components/FormInner");
const Message_1 = require("../../atoms/Message");
const formContext_1 = require("./examples/helpers/formContext");
const FieldInputs_1 = require("./components/FieldInputs");
const Form_1 = require("../../../../lib/Form");
const Collapse_1 = require("../../atoms/Collapse");
const styles = require("./styles.scss");
const cssComposer_1 = require("../../../../helpers/cssComposer");
const css = (0, cssComposer_1.default)(styles, "Form");
/**
 * Produces a form based on a schema. Forms are highly functional components - please refer
 * to the readme for details of each feature.
 */
class Form extends React.PureComponent {
    constructor(props) {
        super(props);
        this.setFieldValue = (value, field) => {
            this.form.set(value, field);
        };
        this.clearFieldValue = (field) => {
            this.form.clearField(field);
        };
        // Creates a new group instance
        this.newGroupInstance = (field) => {
            this.form.createGroupInstance(field);
        };
        this.removeGroupInstance = (field) => {
            this.form.removeGroupInstance(field);
        };
        this.onSubmit = () => {
            const { onError = () => { }, disableOnSuccess = true } = this.props;
            // Prevent editing during submit
            this.form.disable();
            this.setState({ fields: this.form.getFields(), errorMsg: false });
            return this.form.validate().then((errorCount) => {
                // Ensure the button shows an error
                if (errorCount) {
                    this.setState({
                        errorMsg: "Some of the fields are incorrect - please review and submit again."
                    });
                    // allow it to be re-edited
                    this.form.enable();
                    // report back
                    onError();
                    return Promise.reject();
                }
                // allow it to be re-edited
                if (!disableOnSuccess) {
                    this.form.enable();
                }
                // Check if we need to wait for the calling class
                const remoteExec = _.isFunction(this.props.onSuccess)
                    ? this.props.onSuccess(this.form.exportData())
                    : false;
                // Check if the external promises fails and show an error message
                const isPromise = remoteExec && remoteExec.constructor === Promise;
                if (!isPromise) {
                    return;
                }
                return remoteExec.catch((err) => {
                    // show a general purpose error on behalf of the parent component
                    this.setState({ errorMsg: _.get(err, "errorMsg") || true });
                    // re-enable on error
                    this.form.enable();
                    return Promise.reject(err);
                });
            });
        };
        this.onCancel = (externalCallback) => {
            if (_.isFunction(externalCallback)) {
                // return the current state
                externalCallback(this.form.exportData());
            }
        };
        if (props.form) {
            // allow the parent component to pass a Form object
            this.form = props.form;
        }
        else {
            // create a Form object based on the passed details
            this.form = new Form_1.Form(props.schema, props.data, props.dataTransformers, props.client);
        }
        this.state = {
            fields: this.form.getFields(),
            errorMsg: false
        };
        // respond to styleForm changes
        this.form.registerOnChangeCallback((fields) => {
            this.setState({ fields });
        });
    }
    render() {
        const { fields = [], errorMsg } = this.state;
        const { title, submitLabel, onCancel = false, cancelLabel = "Cancel" } = this.props;
        const { onSubmit } = this;
        const provider = {
            setFieldValue: this.setFieldValue,
            clearFieldValue: this.clearFieldValue,
            newGroupInstance: this.newGroupInstance,
            removeGroupInstance: this.removeGroupInstance
        };
        return (React.createElement(formContext_1.FormContext.Provider, { value: provider },
            React.createElement("div", { className: css("") },
                React.createElement(FormInner_1.FormInner, { onSubmit: onSubmit, submitLabel: submitLabel, title: title, onCancel: onCancel ? () => this.onCancel(onCancel) : false, cancelLabel: cancelLabel },
                    React.createElement(FieldInputs_1.default, { fields: fields }),
                    React.createElement(Collapse_1.Collapse, { isOpened: !!errorMsg },
                        React.createElement("div", { className: css("error") }, _.isString(errorMsg) ? (React.createElement("div", { "data-test": "customError" },
                            React.createElement(Message_1.ErrorMessage, null,
                                React.createElement(Message_1.MessageBody, null, errorMsg)))) : (React.createElement("div", { "data-test": "genericError" },
                            React.createElement(ErrorPlaceholder_1.ErrorPlaceholder, null)))))))));
    }
}
exports.Form = Form;
// TODO - legacy
exports.default = Form;
//# sourceMappingURL=index.js.map